// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3i413","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1eKq5"};